var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_7603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63269 15.5V5.37953H0.202386V15.5H3.63269ZM1.91798 3.99692C3.11419 3.99692 3.85877 3.21978 3.85877 2.24862C3.83648 1.25556 3.11423 0.5 1.94068 0.5C0.767312 0.5 0 1.25558 0 2.24862C0 3.21983 0.744398 3.99692 1.89559 3.99692H1.91787H1.91798ZM5.53135 15.5H8.96165V9.84824C8.96165 9.54576 8.98394 9.2436 9.07452 9.02738C9.32251 8.42304 9.88693 7.79712 10.8345 7.79712C12.0758 7.79712 12.5724 8.7252 12.5724 10.0857V15.4999H16.0025V9.69695C16.0025 6.58834 14.3101 5.14193 12.0532 5.14193C10.2027 5.14193 9.39021 6.15626 8.93883 6.84712H8.96173V5.37932H5.53143C5.57644 6.32897 5.53143 15.4998 5.53143 15.4998L5.53135 15.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_7603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.6fea276822876868b0b27461318f90c8.svg";
export { ForwardRef as ReactComponent };